import { Box, Skeleton, styled } from '@mui/material'
import { isEmpty } from 'ramda'
import React from 'react'

import RightDrawer from '@/app/component/atom/right-drawer'
import { ContactType } from '@/app/module/conversations/types'

import ContactInfo from './contact-info'

type Props = {
  contactInfo: ContactType | {}
  loading: boolean
  open: boolean

  onClose: () => void
  onOpen: () => void
}

export const CONVERSATION_DRAWER_WIDTH = 350

const ConversationDrawer: React.FC<Props> = ({ contactInfo, loading, open, onClose, onOpen }) => (
  <Container>
    <RightDrawer
      id="conversation-drawer"
      open={open}
      closeTooltip="Close contact info"
      openButtonTop="76px"
      openTooltip="Open contact info"
      width={CONVERSATION_DRAWER_WIDTH}
      onClose={onClose}
      onOpen={onOpen}
    >
      {open && (
        <Box sx={{ flex: 1, overflowY: 'auto' }}>
          {loading || isEmpty(contactInfo) ? (
            <ContactInfoSkeleton />
          ) : (
            <ContactInfo contactInfo={contactInfo as ContactType} />
          )}
        </Box>
      )}
    </RightDrawer>
  </Container>
)

const Container = styled('div')(({ theme }) => ({
  '& .right-drawer-header': {
    backgroundColor: theme.palette.highlight.light,
    borderBottom: `1px solid ${theme.palette.border.main}`,
    height: 51,
  },
}))

const ContactInfoSkeleton: React.FC = () => (
  <Box>
    <Box sx={{ p: '10px 20px', mb: '5px' }}>
      <Skeleton variant="rectangular" height={76} />
    </Box>
    <Box sx={{ px: 2, mb: '5px' }}>
      <Skeleton variant="rectangular" height={40} />
    </Box>
    <Box sx={{ px: 2, mb: '5px' }}>
      <Skeleton variant="rectangular" height={40} />
    </Box>
    <Box sx={{ px: 2, mb: '5px' }}>
      <Skeleton variant="rectangular" height={40} />
    </Box>
    <Box sx={{ px: 2, mb: '5px' }}>
      <Skeleton variant="rectangular" height={40} />
    </Box>
  </Box>
)

export default ConversationDrawer
